// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { OrOrOrderQuery, TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, GridApi, IServerSideGetRowsRequest } from 'ag-grid-community';
import { TransactionDef, TransactionRef, TransactionUpdateData } from '../../schema/schema.interface';
import { TransactionStateModel } from './transaction.store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TransactionActions {
  export class GetAllTransaction {
    static readonly type = '[Transaction] GetAllTransaction';
    constructor(public stateSelectorName = 'transactions') {}
  }
  export class OnGetAllQueryTransaction {
    static readonly type = '[Transaction] OnGetAllQuerryTransaction';
    constructor(
      public request: OrOrOrderQuery<TransactionDef>[],
      public stateSelectorName: keyof Pick<TransactionStateModel, 'transactions' | 'doneTransactions'> = 'transactions',
    ) {}
  }

  export class OnQueryTransaction {
    static readonly type = '[Transaction] OnGetAllQuerryTransaction';
    constructor(
      public request: IServerSideGetRowsRequest,
      public stateSelectorName: keyof Pick<TransactionStateModel, 'transactions' | 'doneTransactions'> = 'transactions',
      public isResetAfterFilterOrSort = false,
    ) {}
  }
  export class OnGetAllTransaction {
    static readonly type = '[Transaction] OnGetAllTransaction';
    constructor(public stateSelectorName = 'transactions') {}
  }

  export class InitTransactionsCount {
    static readonly type = '[Transaction] InitTransactionCount';
    readonly type = InitTransactionsCount.type;
  }

  export class InitTransactions {
    static readonly type = '[Transaction] InitTransactions';
    readonly type = InitTransactions.type;
  }
  export class CountTransactions {
    static readonly type = '[Transaction] CountTransactions';
    readonly type = CountTransactions.type;
  }

  export class CloseTransactionsConnection {
    static readonly type = '[Transaction] CloseTransactionsConnection';
    readonly type = CloseTransactionsConnection.type;
  }

  export class GetTransactionById {
    static readonly type = '[Transaction] GetTransactionById';
    readonly type = GetTransactionById.type;
  }

  export class UpdateTransaction {
    static readonly type = '[Transaction] UpdateTransaction';
    constructor(
      public transactionData: Partial<TransactionUpdateData>,
      public ref: TransactionRef,
    ) {}
  }

  export class SetFilter {
    static readonly type = '[Transaction] SetFilter';
    constructor(public filter: Partial<FilterModel | AdvancedFilterModel | null>) {}
  }

  export class UpdateTransactionResult {
    static readonly type = '[Transaction] UpdateTransactionResult';
    constructor(
      public data: Array<TypesaurusCoreDoc<TransactionDef> | null | undefined>,
      public stateSelectoreName: keyof TransactionStateModel,
    ) {}
  }

  export class DeleteTransactions {
    static readonly type = '[Transaction] DeleteTransactions';
    constructor(public refs: TransactionRef[]) {}
  }

  export class PaginateQueryTransaction {
    static readonly type = '[Transaction] PaginateQueryTransaction';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class TransactionError {
    static readonly type = '[Transaction] TransactionError';
    constructor(public error: Error) {}
  }

  export class SaveTransaction {
    static readonly type = '[Transaction] SaveTransaction';
    constructor(
      public transactionData: TransactionUpdateData,
      public ref?: TransactionRef,
    ) {
      console.log('savetransaction-action file', { transactionData, ref });
    }
  }

  export class AddGrid {
    static readonly type = '[Transaction] Add Grid';
    constructor(
      public uGridName: string,
      public api: GridApi,
    ) {}
  }

  export class GetSumOf {
    static readonly type = '[Transaction] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }

  export class GetSumsCountOf {
    static readonly type = '[Transaction] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }
}
